import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Response } from '@ui/src';
import { ColumnItems } from '../../../../components/export-column/types';
import { exportPspApi } from '../services';

export interface ExportBanksState {
  banks: ColumnItems[];
}

const initialState: ExportBanksState = {
  banks: [],
};

export const exportBanksSlice = createSlice({
  name: 'exportBanks',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      exportPspApi.endpoints.getExportPspPartners.matchFulfilled,
      (
        state,
        action: PayloadAction<
          Response<{ id: string; companyName: string; exportFileType?: string }>
        >,
      ) => {
        state.banks = action.payload.data.edges.map((item) => ({
          id: item.node.id,
          name: item.node.companyName,
          exportFileType: item.node?.exportFileType,
        }));
      },
    );
  },
});

export default exportBanksSlice.reducer;
